import { useSelector } from 'react-redux'

import { useGetExperimenterConfigQuery } from 'root-api'
import { currentUserSelector, calAnonymousIdSelector } from 'selectors/user'
import { useIdentityReady } from 'contexts/IdentityContext'

export const usePackageExperimenterConfig = (profile) => {
  const currentUser = useSelector(currentUserSelector)
  const calAnonymousId = useSelector(calAnonymousIdSelector)
  const isIdentityReady = useIdentityReady()

  return useGetExperimenterConfigQuery(
    {
      organizationUuid: profile?.organization_uuid,
      locale: profile?.locale,
      ...(currentUser?.uuid && { userId: currentUser.uuid }),
      ...(calAnonymousId && { anonymousId: calAnonymousId }),
    },
    {
      skip: !isIdentityReady || !profile?.organization_uuid || !profile?.locale,
    },
  )
}
